(function () {
  'use strict';

  if (window.ApProductCard && window.ApProductCard.loaded) return;

  function initWishlist(btn) {
    if (btn.dataset.apProductCardWishlistInitialized === 'true') return;

    var buttonClass = Array.prototype.slice.call(btn.classList).find(function (className) {
      return className.indexOf('product-info__wishlist-button-') === 0;
    });

    if (btn.dataset.wlhId) {
      var buttonInfo = {
        ButtonClassElement: buttonClass || 'ap-product-card__wishlist',
        ProductId: btn.dataset.wlhId,
        ProductLink: btn.dataset.wlhLink,
        ProductVariantId: btn.dataset.wlhVariantid,
        ProductPrice: Number(btn.dataset.wlhPrice),
        ProductTitle: btn.dataset.wlhName,
        ProductImage: btn.dataset.wlhImage,
        ButtonMode: btn.dataset.wlhMode || 'icon_only',
        WishlistHash: btn.dataset.wlhView || 'Product'
      };

      if (window.WishListHero_SDK && typeof window.WishListHero_SDK.InitializeAddToWishListButton === 'function') {
        window.WishListHero_SDK.InitializeAddToWishListButton(buttonInfo);
      } else {
        document.dispatchEvent(new CustomEvent('wishlist-hero-add-to-custom-element', { detail: btn }));
      }
    }

    btn.dataset.apProductCardWishlistInitialized = 'true';
  }

  function initGallery(card) {
    if (card.dataset.apProductCardGalleryInitialized === 'true') return;
    card.dataset.apProductCardGalleryInitialized = 'true';

    var images = Array.prototype.slice.call(card.querySelectorAll('[data-ap-product-card-gallery-image]'));
    var prevBtn = card.querySelector('[data-ap-product-card-gallery-prev]');
    var nextBtn = card.querySelector('[data-ap-product-card-gallery-next]');

    if (images.length < 2 || !prevBtn || !nextBtn) return;

    var activeIndex = images.findIndex(function (image) {
      return image.classList.contains('is-active');
    });

    if (activeIndex < 0) activeIndex = 0;

    function isHoverImageVisible() {
      return !card.classList.contains('ap-product-card--gallery-browsing')
        && !card.classList.contains('ap-product-card--photo-preview')
        && card.matches(':hover');
    }

    function getVisibleIndex() {
      var hoverImage = card.querySelector('.ap-product-card__media-image--hover');
      var hoverIndex = images.indexOf(hoverImage);

      if (hoverIndex > -1 && isHoverImageVisible()) {
        return hoverIndex;
      }

      return activeIndex;
    }

    function setActiveImage(nextIndex) {
      activeIndex = (nextIndex + images.length) % images.length;
      card.classList.add('ap-product-card--gallery-browsing');

      images.forEach(function (image, index) {
        var active = index === activeIndex;
        image.classList.toggle('is-active', active);
        image.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }

    card.addEventListener('ap:photo-preview', function () { setActiveImage(0); });

    prevBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setActiveImage(getVisibleIndex() - 1);
    });

    nextBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setActiveImage(getVisibleIndex() + 1);
    });

    card.addEventListener('mouseleave', function () {
      card.classList.remove('ap-product-card--gallery-browsing');
    });
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-ap-product-card-wishlist]').forEach(initWishlist);
    scope.querySelectorAll('[data-ap-product-card-gallery]').forEach(initGallery);
  }

  window.ApProductCard = window.ApProductCard || {};
  window.ApProductCard.init = init;
  window.ApProductCard.loaded = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) init(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var section = document.getElementById(event.detail.sectionId);
      if (section) init(section);
    });
  }
})();
